import { render, staticRenderFns } from "./index_v2.0.vue?vue&type=template&id=7d09684c&scoped=true&"
import script from "./index_v2.0.vue?vue&type=script&lang=js&"
export * from "./index_v2.0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d09684c",
  null
  
)

export default component.exports